export function matchNullOrEmptyToUndefined<T>(val: any): T | undefined {
	if (val === undefined || val === null || val === '') {
		return undefined;
	} else {
		return val as T;
	}
}
